module.exports = "/images/link-icon.svg?60eda25b6048f532784c40c667412545";